import type {Insight} from "../../../models/api/insight/Insight";
import {insights as insights20260205} from "./20260205";
import {insights as insights20260213} from "./20260213";
import {insights as insights20260611} from "./20260611";
import {insights as insights20260618} from "./20260618";
import {insights as insights20260701} from "./20260701";
import {insights as insights20260709} from "./20260709";
import {insights as insights20260727} from "./20260727";
import {insights as insights20260904} from "./20260904";
import {insights as insights20261009} from "./20261009";

const insights: Array<Insight> = [
    ...insights20261009,
    ...insights20260904,
    ...insights20260727,
    ...insights20260709,
    ...insights20260701,
    ...insights20260618,
    ...insights20260611,
    ...insights20260213,
    ...insights20260205,
];

export {
    insights,
};
